import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: "https://047be1a8bb706f7faa6fb16cc7d9f998@o4509052851781632.ingest.us.sentry.io/4509052855255040",
});

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<RemixBrowser />
		</StrictMode>,
	);
});
